import { api } from '@api'

export const deleteEvent = async (id: string) => {
	const { error } = await api().from('events').delete().eq('id', id)

	if (error) {
		console.error('Error deleting event:', error)
		throw new Error(error.message)
	}

	return true
}
